import PlatformOrganizationsList from './PlatformOrganizationsList';

export default PlatformOrganizationsList;
